<span>{{ label | translate }}: </span>
<span>{{ name }}</span>
